import React from 'react';
import {connect} from "react-redux";
import {Col, Row} from "antd";
import {BID} from "../../services";
import {FileController} from "../Boilerplate/FileController";
import ChatWall from "../Boilerplate/ChatWall";

const docKey = ['match', 'params', 'bidId'];
const subDocKey = null;
const indexType = 'bid';
const topLevelName = 'Bid';

const _BidFiles = FileController(BID, indexType, docKey, subDocKey, topLevelName);

const BidFilesContainer = ({bidId}) => <Row gutter={24} align='top'>
  <Col xs={24} lg={17}>
    <_BidFiles/>
  </Col>
  <Col xs={24} lg={7}>
    <ChatWall bidId={bidId} />
  </Col>
</Row>;

export const BidFiles = connect(
  (state, props) => ({ bidId: props.match.params.bidId }),
)(BidFilesContainer);



// WEBPACK FOOTER //
// ./src/components/Bids/BidFiles.js